import React, { useEffect, useState } from 'react'
import {
    Paper, Table, TableBody, TableCell, TableHead, TableRow, Button, Dialog, DialogContent,
    DialogTitle, Grid, TextField, FormControl, FormControlLabel, Switch
} from '@material-ui/core'
import EditIcon from '@material-ui/icons/Edit'
import DeleteIcon from '@material-ui/icons/Delete'
import { globalGetService, globalPostService, globalPutService, globalDeleteService } from '../../../globalServices'
import { EmptyCollection, STableLoader, DeletePopUp, PageLoader } from '../../shared_elements'
import { checkApiStatus } from '../../utils_v2'
import { toastFlashMessage } from '../../../utils'
import ConfigSideNav from './ConfigSideNav'

function AssetManager() {
    const [isLoading, setLoading] = useState(false)
    const [assetManagerList, setAssetManagerList] = useState([])
    const [addEditModal, setAddEditModal] = useState(false)
    const [assetManagerData, setAssetManagerData] = useState({})
    const [error, setError] = useState({})
    const [deleteAssetManager, setDeleteAssetManager] = useState({ modal: false, data: null })
    const [actionLoading, setActionLoading] = useState(false)

    useEffect(() => {
        getAssetManagerListing()
    }, [])

    const getAssetManagerListing = (showSkeleton = true) => {
        if (showSkeleton) {
            setLoading(true)
        }
        return globalGetService('console/asset-managers/')
            .then(response => {
                if (showSkeleton) {
                    setLoading(false)
                }
                if (checkApiStatus(response)) {
                    setAssetManagerList(response?.data?.data?.list || [])
                }
            })
    }

    const onFieldChange = (keyParam, value) => {
        setAssetManagerData({ ...assetManagerData, [keyParam]: value })
    }

    const toggleModalFn = () => {
        setAddEditModal(false)
        setAssetManagerData({})
        setError({})
    }

    const statusChangeFn = (item, value) => {
        setActionLoading(true)
        globalPutService(`console/asset-managers/${item?.id}/`, { ...item, is_enabled: value })
            .then(response => {
                if (checkApiStatus(response)) {
                    getAssetManagerListing(false).then(() => setActionLoading(false))
                    toastFlashMessage(response.data.message || 'Asset Manager updated successfully', 'success')
                } else {
                    setActionLoading(false)
                    toastFlashMessage(response.data.message, 'error')
                }
            })
    }

    const addEditAssetManagerFn = () => {
        let validationInputs = {
            initials: assetManagerData?.initials ? '' : 'Please Enter Initials',
            full_name: assetManagerData?.full_name ? '' : 'Please Enter Full Name',
        }
        if (Object.keys(validationInputs).every(key => validationInputs[key] === '')) {
            const payload = {
                initials: assetManagerData?.initials,
                full_name: assetManagerData?.full_name,
                is_enabled: assetManagerData?.is_enabled !== undefined ? assetManagerData?.is_enabled : true
            }
            setActionLoading(true)
            if (assetManagerData?.id) {
                globalPutService(`console/asset-managers/${assetManagerData?.id}/`, payload)
                    .then(response => {
                        if (checkApiStatus(response)) {
                            toggleModalFn()
                            getAssetManagerListing(false).then(() => setActionLoading(false))
                            toastFlashMessage(response.data.message || 'Asset Manager updated successfully', 'success')
                        } else {
                            setActionLoading(false)
                            toastFlashMessage(response.data.message, 'error')
                        }
                    })
            } else {
                globalPostService('console/asset-managers/', payload)
                    .then(response => {
                        if (checkApiStatus(response)) {
                            toggleModalFn()
                            getAssetManagerListing(false).then(() => setActionLoading(false))
                            toastFlashMessage(response.data.message || 'Asset Manager added successfully', 'success')
                        } else {
                            setActionLoading(false)
                            toastFlashMessage(response.data.message, 'error')
                        }
                    })
            }
        } else {
            setError(validationInputs)
        }
    }

    const onDeleteAssetManager = () => {
        setActionLoading(true)
        globalDeleteService(`console/asset-managers/${deleteAssetManager?.data?.id}/`)
            .then(response => {
                if (checkApiStatus(response)) {
                    setDeleteAssetManager({ modal: false, data: null })
                    getAssetManagerListing(false).then(() => setActionLoading(false))
                    toastFlashMessage(response.data.message || 'Asset Manager deleted successfully', 'success')
                } else {
                    setActionLoading(false)
                    toastFlashMessage(response.data.message, 'error')
                }
            })
    }

    return (
        <section className='config-container' style={{ margin: '24px 0 0 75px' }}>
            <Paper elevation={0} className="tech-specs-card console-paper" style={{ minHeight: `${window.innerHeight - 82}px` }}>
                <ConfigSideNav />
                <div className="tech-specs-content">
                    <div style={{ textAlign: 'right' }}>
                        <Button
                            style={{ marginBottom: '15px' }}
                            onClick={() => { setAssetManagerData({ is_enabled: true }); setError({}); setAddEditModal(true) }}
                            color='primary'
                            size='small'
                            variant='contained'
                        >
                            Add Asset Manager
                        </Button>
                    </div>
                    <Paper>
                        <Table className='mui-table-format'>
                            <TableHead>
                                <TableRow>
                                    <TableCell>Initials</TableCell>
                                    <TableCell>Full Name</TableCell>
                                    <TableCell width='150px'>Status</TableCell>
                                    <TableCell>Action</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {
                                    isLoading ? null : assetManagerList?.map((item, index) =>
                                        <TableRow key={item?.id || index}>
                                            <TableCell>{item?.initials || '--'}</TableCell>
                                            <TableCell>{item?.full_name || '--'}</TableCell>
                                            <TableCell>
                                                <FormControl component="fieldset">
                                                    <FormControlLabel
                                                        control={<Switch color='primary' checked={!!item?.is_enabled} onChange={(e, value) => statusChangeFn(item, value)} />}
                                                        label={item?.is_enabled ? 'Enabled' : 'Disabled'}
                                                    />
                                                </FormControl>
                                            </TableCell>
                                            <TableCell>
                                                <EditIcon
                                                    onClick={() => { setAssetManagerData(item); setError({}); setAddEditModal(true) }}
                                                    color='primary'
                                                    fontSize='small'
                                                    style={{ cursor: 'pointer', marginRight: '10px' }}
                                                />
                                                <DeleteIcon
                                                    onClick={() => setDeleteAssetManager({ modal: true, data: item })}
                                                    color='secondary'
                                                    fontSize='small'
                                                    style={{ cursor: 'pointer' }}
                                                />
                                            </TableCell>
                                        </TableRow>
                                    )
                                }
                            </TableBody>
                        </Table>
                        {isLoading ? <STableLoader count={4} /> : null}
                        {!assetManagerList?.length && !isLoading ? <div style={{ textAlign: 'center' }}><EmptyCollection title={'No records found'} /></div> : null}
                    </Paper>
                    <Dialog
                        open={!!addEditModal}
                        onClose={toggleModalFn}
                        className='console-management-modal'
                        maxWidth="md"
                    >
                        <DialogTitle id="scroll-dialog-title">
                            {assetManagerData?.id ? 'Edit Asset Manager' : 'Add Asset Manager'}
                        </DialogTitle>
                        <DialogContent dividers={true}>
                            <div style={{ width: '380px' }}>
                                <Grid container spacing={1}>
                                    <Grid item md={12}>
                                        <TextField
                                            required
                                            id='initials'
                                            label='Initials'
                                            value={assetManagerData?.initials || ''}
                                            error={!!error.initials}
                                            helperText={error?.initials || ''}
                                            onFocus={() => setError({ ...error, 'initials': '' })}
                                            fullWidth
                                            margin="normal"
                                            onChange={(e) => onFieldChange('initials', e.target.value)}
                                            InputLabelProps={{ shrink: true }}
                                            variant='outlined'
                                        />
                                    </Grid>
                                    <Grid item md={12}>
                                        <TextField
                                            required
                                            id='fullName'
                                            label='Full Name'
                                            value={assetManagerData?.full_name || ''}
                                            error={!!error.full_name}
                                            helperText={error?.full_name || ''}
                                            onFocus={() => setError({ ...error, 'full_name': '' })}
                                            fullWidth
                                            margin="normal"
                                            onChange={(e) => onFieldChange('full_name', e.target.value)}
                                            InputLabelProps={{ shrink: true }}
                                            variant='outlined'
                                        />
                                    </Grid>
                                    <Grid item md={12}>
                                        <FormControl component="fieldset">
                                            <FormControlLabel
                                                control={<Switch color='primary' checked={!!assetManagerData?.is_enabled} onChange={(e, value) => onFieldChange('is_enabled', value)} />}
                                                label={assetManagerData?.is_enabled ? 'Enabled' : 'Disabled'}
                                            />
                                        </FormControl>
                                    </Grid>
                                    <Grid item md={12} style={{ textAlign: "right" }}>
                                        <Button color='primary' size='small' variant='outlined' style={{ marginRight: "10px" }} onClick={toggleModalFn}>
                                            Cancel
                                        </Button>
                                        <Button color='primary' size='small' variant='contained' onClick={addEditAssetManagerFn}>
                                            Save
                                        </Button>
                                    </Grid>
                                </Grid>
                            </div>
                        </DialogContent>
                    </Dialog>
                    <DeletePopUp
                        modal={deleteAssetManager?.modal}
                        title='Delete Asset Manager'
                        content={`Are you sure, you want to delete '${deleteAssetManager?.data?.full_name || ''}'?`}
                        toggleModalFn={() => setDeleteAssetManager({ modal: false, data: null })}
                        deleteRecordFn={onDeleteAssetManager}
                    />
                    {actionLoading ? <PageLoader /> : null}
                </div>
            </Paper>
        </section>
    )
}

export default AssetManager
